import { rest } from 'msw';
import { ModelPerformanceMapData } from 'types/Meteorology/Fields/ModelPerformance/mapData';
import { mockGeoJsonBasins, mockGeoJsonRegions } from './geoJsonData';

export const mockedGetModelPerformanceOptionsResponse = {
  status: 1,
  code: 200,
  type: 2,
  title: 'Sucesso',
  message: 'Opções do painel carregadas com sucesso',
  data: {
    analysis_types: [
      { id: 'bacia', label: 'Bacia' },
      { id: 'regiao', label: 'Região' },
    ],
    variables: [
      { id: 'prec', label: 'Precipitação' },
      { id: 'temp', label: 'Temperatura' },
    ],
    deadlines: [
      { id: 'curto', label: 'Curto Prazo' },
      { id: 'longo', label: 'Longo Prazo' },
    ],
    pentads: [
      { id: '1', label: 'Pentada 1' },
      { id: '2', label: 'Pentada 2' },
      { id: '3', label: 'Pentada 3' },
      { id: 'livre', label: 'Livre' },
    ],
    min_date: '2025-03-01',
    max_date: '2026-03-01',
    available_rounds: [
      '2025-12-15',
      '2025-12-20',
      '2025-12-25',
      '2025-01-01',
      '2025-01-05',
      '2025-01-10',
      '2025-01-15',
      '2026-01-20',
      '2026-01-25',
      '2026-01-30',
    ],
  },
};

/** Retorna dados mockados do mapa para uso quando a rota da API ainda não estiver disponível. */
export function getMockMapData(analysisType: 'basin' | 'region'): ModelPerformanceMapData {
  const geoJson = analysisType === 'basin' ? mockGeoJsonBasins : mockGeoJsonRegions;

  const legend = [
    {
      min: 0,
      max: 30,
      color: '#1565c0',
      label: 'Muito baixo',
    },
    {
      min: 30,
      max: 50,
      color: '#2196f3',
      label: 'Baixo',
    },
    {
      min: 50,
      max: 70,
      color: '#00c853',
      label: 'Médio',
    },
    {
      min: 70,
      max: 90,
      color: '#ff9800',
      label: 'Alto',
    },
    {
      min: 90,
      max: null,
      color: '#f44336',
      label: 'Muito alto',
    },
  ];

  return {
    geoJson,
    legend,
    variable: 'Precipitação',
    unit: 'mm',
  };
}

export const mockedGetModelPerformanceMapDataResponse = (
  analysisType: 'basin' | 'region' = 'basin',
) => ({
  status: 1,
  code: 200,
  type: 2,
  title: 'Sucesso',
  message: 'Dados carregados com sucesso.',
  data: getMockMapData(analysisType),
});

export const getModelPerformanceOptionsURL = `${process.env.REACT_APP_AMPERE_API_URL}/produtos/desempenho-modelos/painel-options/`;
export const getModelPerformanceOptionsHandler = rest.get(
  getModelPerformanceOptionsURL,
  (_req, res, ctx) => (
    res(ctx.status(200), ctx.json(mockedGetModelPerformanceOptionsResponse), ctx.delay(30))
  ),
);

export const getModelPerformanceMapDataURL = `${process.env.REACT_APP_AMPERE_API_URL}/produtos/meteorologia/mapas-meteogramas/desempenho-de-modelos/visao-geral/camadas-mapa`;
export const getModelPerformanceMapDataHandler = rest.post(
  getModelPerformanceMapDataURL,
  async (req, res, ctx) => {
    const body = await req.json() as { analysis_type?: 'basin' | 'region'; variavel?: string };
    const analysisType = body.analysis_type || 'basin';

    return res(
      ctx.status(200),
      ctx.json(mockedGetModelPerformanceMapDataResponse(analysisType)),
      ctx.delay(500), // Simular latência de ~500ms
    );
  },
);
